import { CaseQuery } from 'dashboard/models/case-query';
import Action from 'lib/interfaces/Action';

export type CaseQueriesActions = Action<
  CaseQueriesActionType.SetCaseQueries,
  SetCaseQueriesPayload
>;

export enum CaseQueriesActionType {
  SetCaseQueries = 'case-queries/SET_CASE_QUERIES',
}

interface SetCaseQueriesPayload {
  caseQueries: CaseQuery[];
}

export function setCaseQueries(
  caseQueries: CaseQuery[],
): Action<CaseQueriesActionType.SetCaseQueries, SetCaseQueriesPayload> {
  return {
    payload: {
      caseQueries,
    },
    type: CaseQueriesActionType.SetCaseQueries,
  };
}
